import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ContentCopyOutlined, DeleteOutlined, EditOutlined, VisibilityOutlined } from '@mui/icons-material';
import { CustomWarningDelete } from '../../CustomWarningDelete';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { UpdateQuestionForm } from './UpdateQuestionForm';
import { DuplicateQuestionForm } from './DuplicateQuestionForm';
import { useModalStore } from '../../../store/useModalStore';

export const Actions = ({ data, updated, duplicated, deleted }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef: { current: { handleOpen } } } = useContext(ModalsContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'preguntas')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    // const openModal = (form) => handleOpen(form);

    const buttons = [
        { icon: <ContentCopyOutlined color='action' fontSize='small' />, action: () => openModal(<DuplicateQuestionForm data={ data } action={ duplicated } />) },
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => false },
        { icon: <EditOutlined color='action' fontSize='small' />, action: () => openModal(<UpdateQuestionForm data={ data } action={ (e) => updated({ ...e, _id: data?._id }) } />)  },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<CustomWarningDelete action={ () => deleted(data?._id) } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}